import React from 'react';
import Header from '../Header';
import MapComponent from '../Map';
import Map from './Map';
import {
  AbsoluteLayout,
  AbsoluteLayoutHeader,
  AbsoluteLayoutBody,
  AbsoluteLayoutFooter
} from '../FixedLayout';
import './index.css';
import { latLngDecimalToStandard } from '../../helpers/poi';

export default class AddressMap extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      staytime: 0,
      center: props.center || {}
    };
  }

  render(){
    let { name, handleLeftButtonClick, className } = this.props;
    let { center } = this.state;
    
   
    return(
      <AbsoluteLayout id="address-map" className={className ? className : ''}>
        <AbsoluteLayoutHeader height="0.88rem">
          <Header title={name} handleLeftButtonClick={handleLeftButtonClick}/>
        </AbsoluteLayoutHeader>

        <AbsoluteLayoutBody className="address-map-body">
          <div className="tips-title">
            <p>拖动地图设置定义点的位置</p>
          </div>
          <div className="item-map-wrap">
            <MapComponent 
              limitBounds={true}
              markers={[this.getCenterMarker()]}
              onDragEnd={this.handleMapChangeEnd}
              onZoomEnd={this.handleMapChangeEnd}/>
            {/* <Map 
              center={[center.lat, center.lng]}
              onDragEnd={this.handleMapChangeEnd}
              onZoomEnd={this.handleMapChangeEnd}/> 
            <div className="fake-locate-marker">
              <div className="pic locate" style={{backgroundImage:`url(${image})`}}></div>
            </div>
            */}
          </div>
        </AbsoluteLayoutBody>
        <AbsoluteLayoutFooter height="1rem">
          <div className="latlng">
            <i className="icon icon-hotel_recommend_addr"></i>
            <p>
              {latLngDecimalToStandard(center.lat, 'lat') + ', ' + latLngDecimalToStandard(center.lng, 'lng')}
            </p>
          </div>
          <div className="save-btn" onClick={this.saveAddress}><span>保存</span></div>
        </AbsoluteLayoutFooter>
      </AbsoluteLayout>
    );
  }

  getCenterMarker = ()=>{
    let { center } = this.state;
    let marker = center.lat && center.lng ? {
      type: 'locateMarker',
      className: 'locate',
      size: {
        width: '0.6rem',
        height: '0.6rem'
      },
      latLng:[center.lat, center.lng],
      imageUrl: '//imgcdn5.zuzuche.com/m_tantu_image/20180130/8095666e20b3206ab9c08f4b6af334a6.png'
    } : {};

    return marker;
  }

  handleMapChangeEnd = (map, type)=>{
    //首次渲染不做center更新
    this.firstTimeFitbounds = true;
    if(this.firstTimeFitbounds && type === 'zoom'){
      this.firstTimeFitbounds = false;
      return;
    }

   
    let _center = map.getCenter();
    console.log(_center);
    this.setState({
      center: {
        lat: this.format(_center.lat), 
        lng: this.format(_center.lng), 
      }
    });
  }

  format(value){
    return Number(value).toFixed(6);
  }

  /**
   * 保存地址
   */
  saveAddress = ()=>{
    let { center } = this.state;
    this.props.saveAddress(center);
  }
}


// WEBPACK FOOTER //
// ./src/components/AddressMap/index.js